require('formdata-polyfill');
const $form = $('.form.form-validate');
const $fileInput = $form.find('input:file');
const $uploadedFilesList = $fileInput.siblings('.form_file-names');
const allowExt = 'jpe?g|png|gif|doc|docx|rtf|pdf|tiff|bmp|avi|wmv|mp4|mov|mpeg1|mpeg2';
let newFileList = [];
let submitted = false;

export default function() {
    let $formValidator = $form.validate({
        ignore: [],
        rules: {
            name: {
                required: true
            },
            email: {
                required: true,
                email: true
            },
            message: {
                required: true
            },
            gdpr_agreed: {
                required: true
            },
            contact_source_id: {
                required: true
            }
        },
        submitHandler: function (form) {
            if(submitted) return;
            submitted = true;

            const $form = $(form);
            const action = $form.attr('action');
            let data = new FormData($form[0]);

            data.delete('files[]');

            newFileList.forEach(item => {
                data.append('files[]', item);
            });

            const $formState = $form.closest('.form-wrapper').find('.form-wrapper_form-state');
            const $afterState = $form.closest('.form-wrapper').find('.form-wrapper_after-state');

            axios.post(action, data)
                .then(function (response) {
                    if (response.data.status === 'success') {
                        if ($afterState.length) {
                            $formState.fadeOut(function () {
                                $afterState.fadeIn();
                                submitted = false;
                            });
                        }

                        trackEvent('Form', 'submit', window.location.pathname);
                    }
                })
                .catch(function (error) {
                    submitted = false;
                    console.log('Form error.');
                });
        }
    });

    let messages = {
        'en':
            {
                name: {
                    required: "Your name and surname are mandatory information."
                },
                email: {
                    required: "An e-mail address is mandatory information.",
                        email: "The e-mail is not in the correct format."
                },
                message: {
                    required: "A question is mandatory information.",
                },
                gdpr_agreed: {
                    required: "Súhlas so spracovaním osobných údajov je povinný údaj."
                },
                contact_source_id: {
                    required: "Kontaktný zdroj je povinný údaj."
                }
            },
        'sk':
            {
                name: {
                    required: "Meno a priezvisko je povinný údaj."
                },
                email: {
                    required: "E-mail je povinný údaj.",
                        email: "E-mail nie je v správnom tvare."
                },
                message: {
                    required: "Otázka je povinný údaj.",
                },
                gdpr_agreed: {
                    required: "Súhlas so spracovaním osobných údajov je povinný údaj."
                },
                contact_source_id: {
                    required: "Kontaktný zdroj je povinný údaj."
                }
            }
    }
    if($formValidator) {
        $formValidator.settings.messages = $('html').attr('lang') == 'sk' ? messages['sk'] : messages['en'];
    }

    $fileInput.change(() => {
        const tmpFileList = Array.from($fileInput[0].files);

        let filesize = 0;
        tmpFileList.forEach(tmpFile => {
            const found = newFileList.some(el => el.name === tmpFile.name);

            if (!found) {
                newFileList.push(tmpFile);

                $uploadedFilesList.append(`<span>${tmpFile.name}</span>`);
            }

            newFileList.forEach((file, key) => {
                const ext = file.name.substring(file.name.lastIndexOf('.') + 1);
                if ( ! file.name.match(new RegExp(".(" + allowExt + ")$", "i")) ) {
                    const errors = { 'files[]': 'Nepodporované formáty prílohy.' };
                    $formValidator.showErrors(errors);

                    $form.find('.btn-submit').attr('disabled', true);
                }

                filesize += file.size;
            });
        });

        // not more than 20 MB filesize
        if (filesize / 1000000 > 20) {
            const errors = {'files[]': 'Maximálna veľkosť prílohy: 20 MB'};
            $formValidator.showErrors(errors);

            $form.find('.btn-submit').attr('disabled', true);
        }

        if (newFileList.length >= 2) {

            $fileInput.attr('disabled', true);
            $form.find('.btn-upload').attr('disabled', true);

            if (newFileList.length > 2) {
                const errors = {'files[]': 'Maximálny počet príloh: 2'};
                $formValidator.showErrors(errors);

                $form.find('.btn-submit').attr('disabled', true);
            }
        }

        // clear input value, without this, user cant select the last uploaded file after removing it from queue
        $fileInput.val("");
    });


    $uploadedFilesList.on('click', 'span', event => {
        newFileList.forEach((file, key) => {
            if (`${file.name}` == $(event.target).text()) {
                newFileList.splice(key, 1);
                $(event.target).remove();
            }
        });

        let filesize = 0;
        let extensionError = false;
        newFileList.forEach((file, key) => {
            const ext = file.name.substring(file.name.lastIndexOf('.') + 1);
            if ( ! file.name.match(new RegExp(".(" + allowExt + ")$", "i")) ) {
                extensionError = true;
            }

            filesize += file.size
        });

        let filesizeError = false;
        if (filesize / 1000000 > 20) {
            filesizeError = true;
        }

        let moreThanTwoFilesError = false;
        let twoFilesRestriction = false;
        if (newFileList.length > 2) {
            moreThanTwoFilesError = true;
        }
        else if (newFileList.length == 2) {
            twoFilesRestriction = true;
        }

        if (extensionError) {
            const errors = { 'files[]': 'Nepodporované formáty prílohy.' };
            $formValidator.showErrors(errors);
        }

        if (filesizeError) {
            const errors = { 'files[]': 'Maximálna veľkosť prílohy: 20 MB' };
            $formValidator.showErrors(errors);
        }

        if (moreThanTwoFilesError || twoFilesRestriction) {
            $fileInput.attr('disabled', true);

            if (moreThanTwoFilesError) {
                $form.find('.form_btn').attr('disabled', true);

                const errors = { 'files[]': 'Maximálny počet príloh: 2' };
                $formValidator.showErrors(errors);
            }

            if (twoFilesRestriction) {
                $form.find('.btn-upload').attr('disabled', true);
            }
        }

        if (!extensionError && !filesizeError) {
            $formValidator.element($fileInput);
            $fileInput.attr('disabled', false);
            $form.find('.form_btn').attr('disabled', false);
        }
    });
}
